import React, { Component } from 'react';
import classNames from 'classnames';
import { injectIntl, FormattedMessage } from '@atlassian/jira-intl';
import { Checkbox, STORY_LEVEL } from '@atlassian/jira-portfolio-3-common';
import { Row, Left, Right } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/layout/row';
import AddIssueMenu from './add-issue';
import BulkActions from './bulk-actions';
import CollapseMenu from './collapse-menu';
import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { HierarchyItem, Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class Header extends Component<Props> {
	static defaultProps: Pick<Props, 'BulkActions' | 'CollapseMenu' | 'AddIssueMenu'> = {
		BulkActions,
		CollapseMenu,
		AddIssueMenu,
	};

	getCurrentHierarchyLevels(): HierarchyItem[] {
		const { hierarchy, start, end } = this.props;
		const endExcludingSubtask = Math.max(STORY_LEVEL, end); // Don't create a subtask without a parent.

		return hierarchy.reduce<HierarchyItem[]>((acc, { level, title }) => {
			if (level >= STORY_LEVEL) {
				acc.push({
					id: level,
					title,
					value: level,
					visible: level <= start && level >= endExcludingSubtask,
				});
			}
			return acc;
		}, []);
	}

	render() {
		const {
			isReadOnly = false,
			isExportMode,
			totalSelected,
			isIndeterminate,
			isSelected,
			toggleAllSelected,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			BulkActions,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			CollapseMenu,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			AddIssueMenu,
			intl: { formatMessage },
		} = this.props;
		const currentHierarchyLevels = this.getCurrentHierarchyLevels();
		const className = classNames(styles.spaHeader, { [styles.selected]: isSelected });

		return (
			<>
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={className}
					data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.scope-header"
				>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<Row className={styles['scope-row']}>
						<Left>
							<Row>
								{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
								<Left className={styles.left}>
									{!isExportMode && (
										// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
										<div className={styles.issueHeader}>
											<CollapseMenu />
										</div>
									)}
								</Left>
								{!isReadOnly && !isSelected && currentHierarchyLevels.length > 0 && (
									<Right>
										<AddIssueMenu currentHierarchyLevels={currentHierarchyLevels} />
									</Right>
								)}
							</Row>
						</Left>
						{isSelected && (
							<Right>
								{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
								<div className={styles.bulkActions}>
									<BulkActions />
								</div>
							</Right>
						)}
					</Row>
				</div>
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styles.spaBottomHeader}
					data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.scope-header"
				>
					{!isReadOnly && (
						<>
							<Checkbox
								isChecked={isSelected}
								isIndeterminate={isIndeterminate}
								onChange={toggleAllSelected}
								testId="portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.checkbox"
								aria-label={formatMessage(messages.selectAllIssuesCheckboxAriaLabel)}
							/>
							{isSelected ? (
								<small
									// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
									style={{ margin: 0 }}
									data-testid="portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.issues-selected-count"
								>
									<FormattedMessage {...messages.selectedIssues} values={{ totalSelected }} />
								</small>
							) : (
								// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
								<div className={styles.rankHeader} data-name="rank-header">
									#
								</div>
							)}
						</>
					)}
				</div>
			</>
		);
	}
}

export default injectIntl(Header);
